/** Opt-in row-size choices for CDataTable (`:page-size-options`). */
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100]

export const policyStatuses = [
  { label: 'Draft', value: 'draft' },
  { label: 'Pending Approval', value: 'pending_approval' },
  { label: 'Active', value: 'active' },
  { label: 'Under Review', value: 'under_review' },
  { label: 'Expired', value: 'expired' },
  { label: 'Archived', value: 'archived' },
]

export const getPolicyStatusLabel = (status) => {
  const statusObj = policyStatuses.find(s => s.value === status)
  return statusObj ? statusObj.label : status
}

// Workspace user status — settable values only ("Invited" is system-managed until
// the invite is accepted, so it isn't offered as a manual status target).
export const userStatuses = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
]

// Workspace lifecycle status — API also accepts `pending`; super admins may set
// active / inactive from the workspaces list.
export const workspaceStatuses = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
  { label: 'Pending', value: 'pending' },
]

export const workspaceStatusTargets = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
]

// Compliance Action Center – Case Types (v1)
export const complianceAlertTypes = [
  { label: 'Policy Review', value: 'policy_review' },
  { label: 'Vendor Review', value: 'vendor_review' },
  { label: 'Training', value: 'training' },
  { label: 'Bank / Partner Request', value: 'bank_partner_request' },
  { label: 'Audit / Exam Finding', value: 'audit_exam_finding' },
]

// Compliance Action Center – Case Statuses (v1)
export const complianceAlertStatuses = [
  { label: 'Created', value: 'created' },
  { label: 'In Review', value: 'in_review' },
  { label: 'Escalated', value: 'escalated' },
  { label: 'Closed', value: 'closed' },
]

export const complianceAlertPriorities = [
  { label: 'Low', value: 'low' },
  { label: 'Medium', value: 'medium' },
  { label: 'High', value: 'high' },
]

// Feedback — priority label attached on submit (mirrored to the synced Trello card's label).
export const feedbackLabels = [
  { label: 'Low', value: 'low' },
  { label: 'Medium', value: 'medium' },
  { label: 'High', value: 'high' },
]

export const getFeedbackLabelText = (value) =>
  feedbackLabels.find((l) => l.value === value)?.label ?? value

export const getComplianceAlertTypeLabel = (value) =>
  complianceAlertTypes.find((t) => t.value === value)?.label ?? value

export const getComplianceAlertStatusLabel = (value) =>
  complianceAlertStatuses.find((s) => s.value === value)?.label ?? value